import PlaceOutlined from "@mui/icons-material/PlaceOutlined";

import MiqaatVenueCreate from "./MiqaatVenueCreate";
import MiqaatVenueEdit from "./MiqaatVenueEdit";
import MiqaatVenueList from "./MiqaatVenueList";
import MiqaatVenueShow from "./MiqaatVenueShow";

export default {
  list: MiqaatVenueList,
  create: MiqaatVenueCreate,
  edit: MiqaatVenueEdit,
  show: MiqaatVenueShow,
  icon: PlaceOutlined,
  label: "Venues",
  options: { label: "Venues" },
  name: "miqaatVenues",
};
